import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { useInNewReportPayload } from './google-sheet.models';
import { GoogleSheetDatasetRunPayload } from '@mode/dataset/google/contract';
import { createParams } from './create-params';
import { DocumentIds, extractDocumentIds } from './extract-document-ids';

@Injectable({
  providedIn: 'root',
})
export class GoogleSheetClientService {
  constructor(private _http: HttpClient) {}

  createGoogleSheetDataset(
    tab: string,
    name: string,
    description: string,
    spreadsheetId: string,
    worksheetId: string | number,
    url: string,
    accountId: string,
    token: string,
    layout: string
  ): Observable<GoogleSheetDatasetRunPayload> {
    const ids: DocumentIds = tab === 'By URL' ? extractDocumentIds(url) : { spreadsheetId, worksheetId };
    const params = createParams(name, description, layout, ids.spreadsheetId, ids.worksheetId);

    // Include `trk_type` param in the url to filter google sheets requests in honeycomb
    return this._http.post<GoogleSheetDatasetRunPayload>(
      `/api/${accountId}/reports/${token}/editor/runs?trk_type=google_sheet`,
      params
    );
  }

  useInNewReport(importInNewReportUrl: string): Observable<useInNewReportPayload> {
    return this._http.post<useInNewReportPayload>(importInNewReportUrl, {});
  }
}
